import { render } from "./Dashboard.vue?vue&type=template&id=55ffff3c&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=55ffff3c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-55ffff3c"

export default script